
interface VoucherDetailCardProps {
  voucher: any;
}

function VoucherDetailCard({ voucher }: VoucherDetailCardProps): JSX.Element {
  const date = new Date(voucher.expiryDate);

  return (
    <div className="bg-[#F7EAE4] h-full rounded-2xl  w-full max-w-lg  flex flex-col">
      {/* Voucher Image */}
      <div className="relative overflow-hidden ">
        <img src={voucher.program.voucherImage} alt="Voucher" className="w-full  object-cover rounded-lg" />
        <div className="absolute top-[50%] left-0 w-full h-full flex items-center justify-center">
          <div className="flex space-x-1">
            {Array.from({length: 80}).map((_, index) => (
              <div key={index} className="w-[8px] h-[8px] md:w-[15px] md:h-[15px] bg-[#F7EAE4] rounded-full"></div>
            ))}
          </div>
        </div>
      </div>
      {/* Voucher Details */}
      <div className="md:pr-8 md:pl-8 md:pt-8 pr-4 pl-4 pt-6 bg-[#F7EAE4] flex-grow rounded-2xl  flex flex-col">
        {/* Amount */}
        <div className="text-center md:mb-6">
          <h1 className="text-4xl md:text-7xl font-bold text-[#E31C17]">{voucher.display_currency?.symbol ?? '₹'}{voucher.final_balance}</h1>
          <p className="text-lg font-medium text-[#E31C17] mt-2">
            Valid until {date.toLocaleString("default", { month: "short" })} {date.getDate()}, {date.getFullYear()}
          </p>
        </div>
        {/* Terms & Conditions */}
        <div className="text-sm text-gray-500 mt-4 flex justify-between items-end flex-grow">
          <span className="mb-3 md:text-base text-xs">Terms & Conditions</span>
          <div className="w-20 h-10 bg-white rounded-t-full"></div>
          <img  src="https://saraluat.blr1.cdn.digitaloceanspaces.com/redemption_portal/fincentive%20logo.png" alt="Fincentive Logo" className="md:h-4 h-3 mb-3" />
        </div>
      </div>
    </div>
  );
}

export default VoucherDetailCard;
